// SC-3113 — kept out of `hooks.ts` so the pure editor rules (`cellEdit.ts`) can
// test `instanceof` against it in suites that `vi.mock` the hooks module wholesale.

/**
 * A 409 or an unconfirmed save whose follow-up READ also failed. The cell on
 * screen is then the pre-save value, not a fresh one, so nothing can be concluded
 * from it: it can't prove the edit landed, and it can't prove a refusal. Thrown in
 * place of the original error so the editor says "couldn't check" rather than
 * reading a stale value as an answer. `cause` keeps the original for diagnosis.
 */
export class CellEditUnverifiedError extends Error {
  readonly cause: unknown;
  constructor(cause: unknown) {
    super('The cell could not be re-read after the save failed.');
    this.name = 'CellEditUnverifiedError';
    this.cause = cause;
  }
}
